import React from 'react';
import ButtonComponent from '../../General/Button';

export default function LandingHeader() {
  return (
    <div className="container mx-auto pt-6 cursor-pointer">
      <div className="flex flex-row justify-between gap-8 ">
        <div className="flex gap-4">
          <div className="flex overflow-hidden rounded-full">
            <img src="../../assets/penalogo.svg" className="h-[60px] max-w-[150px] object-center" /> 
          </div>
          <ul className="flex lg:gap-3 mt-5 lg:ml-2">
            <li className="w-[100px] h-[32px] text-lg hover:leading-4 hover:border-b-2 border-red-600 transition-all duration-250">HeyPena</li>
            <li className="w-[100px] h-[32px] text-lg hover:leading-4 hover:border-b-2 border-red-600 transition-all duration-250">
              Özellikler
            </li>
            <li className="w-[100px] h-[32px] text-lg hover:leading-4 hover:border-b-2 border-red-600 transition-all duration-250">Araçlar</li>
            <li className="w-[100px] h-[32px] text-lg hover:leading-4 hover:border-b-2 border-red-600 transition-all duration-250">İletişim</li>
          </ul>
        </div>
        <ButtonComponent id={''} href="/login " title={'Giriş Yap'} bgcolor="bg-red-33 mt-4 rounded-3xl text-white font-semibold w-[100px] lg:block hidden" />
        
      </div>
      <ButtonComponent id={''} href="/login " title={'Giriş Yap'} bgcolor="bg-red-33 mt-4 rounded-3xl text-white font-semibold w-full lg:hidden block" />
    </div>
  )
}
